import { c as _c } from "react/compiler-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cx } from 'class-variance-authority';
import { type ReactNode, useState } from 'react';
export type TooltipProps = {
  children: ReactNode;
  disabled?: boolean;
  content?: string | ReactNode;
  side?: TooltipPrimitive.TooltipContentProps['side'];
  align?: TooltipPrimitive.TooltipContentProps['align'];
  delayOpen?: number;
  fullWidth?: boolean;
  /** Min distance kept from the viewport edges so the tooltip never sits flush against the window. */
  collisionPadding?: TooltipPrimitive.TooltipContentProps['collisionPadding'];
};
const Tooltip = t0 => {
  const $ = _c(25);
  const {
    children,
    disabled,
    content,
    side: t1,
    align: t2,
    delayOpen: t3,
    fullWidth,
    collisionPadding: t4
  } = t0;
  const side = t1 === undefined ? "top" : t1;
  const align = t2 === undefined ? "center" : t2;
  const delayOpen = t3 === undefined ? 0 : t3;
  const collisionPadding = t4 === undefined ? 16 : t4;
  const [open, setOpen] = useState(false);
  if (disabled && open) {
    setOpen(false);
  }
  let t5;
  if ($[0] !== fullWidth) {
    t5 = cx("inline-flex justify-center items-center", {
      "w-full": fullWidth
    }, {
      "w-fit h-fit": !fullWidth
    });
    $[0] = fullWidth;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = !disabled && open;
  let t7;
  if ($[2] !== fullWidth) {
    t7 = cx("inline-block", {
      "h-fit w-fit": !fullWidth
    }, {
      "w-full": fullWidth
    });
    $[2] = fullWidth;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== children || $[5] !== t7) {
    t8 = <TooltipPrimitive.Trigger asChild={true}><div className={t7}>{children}</div></TooltipPrimitive.Trigger>;
    $[4] = children;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cx("max-w-[300px] px-2 py-1 text-wrap text-caption-3 text-quinary text-left rounded bg-tertiary shadow-md z-50 origin-[var(--radix-tooltip-content-transform-origin)]", "[&[data-side=bottom]]:animate-slideDown", "[&[data-side=top]]:animate-slideUp", "[&[data-side=left]]:animate-slideLeft", "[&[data-side=right]]:animate-slideRight", "data-[state=delayed-open]:animate-scaleIn data-[state=delayed-closed]:animate-scaleOut", "data-[state=instant-open]:animate-scaleIn data-[state=instant-closed]:animate-scaleOut");
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== content) {
    t10 = <div className={t9}>{content}</div>;
    $[8] = content;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== align || $[11] !== collisionPadding || $[12] !== side || $[13] !== t10) {
    t11 = <TooltipPrimitive.Portal><TooltipPrimitive.Content align={align} side={side} sideOffset={4} collisionPadding={collisionPadding} asChild={true} forceMount={true}>{t10}</TooltipPrimitive.Content></TooltipPrimitive.Portal>;
    $[10] = align;
    $[11] = collisionPadding;
    $[12] = side;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t6 || $[17] !== t8) {
    t12 = <TooltipPrimitive.Root open={t6} onOpenChange={setOpen}>{t8}{t11}</TooltipPrimitive.Root>;
    $[15] = t11;
    $[16] = t6;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t5) {
    t13 = <div className={t5}>{t12}</div>;
    $[19] = t12;
    $[20] = t5;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== delayOpen || $[23] !== t13) {
    t14 = <TooltipPrimitive.Provider delayDuration={delayOpen}>{t13}</TooltipPrimitive.Provider>;
    $[22] = delayOpen;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};
export default Tooltip;